"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cart = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const ActionTypes = require("../actionTypes/cart");
const AuthActionTypes = require("../actionTypes/auth/login");
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
const initialState = {
    data: {
        status: 'STANDBY',
        items: []
    },
    toggled: false,
    showCartInfo: false
};
const cart = (state = Object.assign({}, initialState), action) => {
    switch (action.type) {
        case ActionTypes.FETCH_ITEMS_REQUEST:
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.FETCHING,
                    items: []
                } });
        case ActionTypes.FETCH_ITEMS_FAILURE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { status: exports.FAILED }) });
        case ActionTypes.FETCH_ITEMS_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.FETCHED,
                    items: action.result.data.data
                } });
        case ActionTypes.ADD_ITEMS:
            const added = action.data.items.filter((x) => {
                for (let i = 0; i < state.data.items.length; i++) {
                    if (state.data.items[i].id === x.id) {
                        return false;
                    }
                }
                return true;
            });
            return Object.assign(Object.assign({}, state), { data: {
                    status: state.data.status,
                    items: state.data.items.concat(added)
                } });
        case ActionTypes.REMOVE_ITEMS: {
            const newItems = state.data.items.reduce((res, i) => {
                if (!action.data.ids.includes(i.id)) {
                    res.push(i);
                }
                return res;
            }, []);
            return Object.assign(Object.assign({}, state), { data: {
                    status: state.data.status,
                    items: newItems
                } });
        }
        case AuthActionTypes.LOGOUT:
        case ActionTypes.CLEAR_ALL:
            return Object.assign(Object.assign({}, state), { data: {
                    status: state.data.status,
                    items: []
                }, toggled: false });
        case ActionTypes.TOGGLE_CART: {
            const isOpen = state.toggled;
            return Object.assign(Object.assign({}, state), { data: {
                    status: isOpen ? exports.STANDBY : state.data.status,
                    items: state.data.items
                }, toggled: !state.toggled });
        }
        case ActionTypes.FETCH_FILES:
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.FETCHING,
                    items: state.data.items
                } });
        case ActionTypes.FETCH_FILES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.FETCHED,
                    items: action.payload.files
                } });
        }
        case ActionTypes.FETCH_FILES_FAILURE:
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.FAILED,
                    items: state.data.items
                } });
        case ActionTypes.CANCEL_FETCH:
            return Object.assign(Object.assign({}, state), { data: {
                    status: exports.STANDBY,
                    items: state.data.items
                } });
        case ActionTypes.SHOW_CART_INFO:
            return Object.assign(Object.assign({}, state), { showCartInfo: action.payload });
        default:
            return state;
    }
};
exports.cart = cart;
//# sourceMappingURL=cart.js.map